var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ForumResponseBodyText",class:_vm.classList,style:(_vm.styleVars)},[_c('div',{staticClass:"ForumResponseBodyText__html"},[_c('ForumResponseBodyTextOutput',{attrs:{"text":_vm.response.mentionProcessedText,"truncate":_vm.truncate,"lines":_vm.lines,"basic-mention":_vm.basicMention,"chat-id":_vm.response.chatId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }